// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomVideo = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.46899 1.03494C4.64272 1.01189 4.81997 1 5 1H7.52389L10.1116 4.88151H7.03337L4.46899 1.03494ZM3.31613 1.37064C1.98207 1.99063 1.04702 3.32451 1.00172 4.88151H1V5C1 4.96037 1.00058 4.92087 1.00172 4.88151H5.65671L3.31613 1.37064ZM1 6.02697V11C1 13.2091 2.79086 15 5 15H11C13.2091 15 15 13.2091 15 11V6.02697H1ZM15 5V4.88151H14.9983C14.9356 2.72718 13.1695 1 11 1H8.90056L11.4882 4.88151H14.9983C14.9994 4.92087 15 4.96037 15 5ZM10.0624 9.48099C10.283 9.61246 10.283 9.94116 10.0624 10.0726L6.58786 12.1434C6.36726 12.2749 6.0915 12.1105 6.0915 11.8476L6.0915 7.70603C6.0915 7.44308 6.36726 7.27873 6.58786 7.41021L10.0624 9.48099Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomVideo };
